import { useAppDispatch } from 'store/hooks';
import { closeModal } from 'features/modal/modalSlice';
import { useTranslation } from 'react-i18next';
import ConfirmationDialog from 'components/ConfirmationDialog';

const RestreamingFailureRuntimeModal = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation('modals');

  const handleCancel = () => {
    dispatch(closeModal('restreamingFailureRuntime'));
  };

  return (
    <ConfirmationDialog
      open
      title={t('restreaming.failure_runtime.title')}
      description={t('restreaming.failure_runtime.description')}
      okText={t('restreaming.failure_runtime.btn_ok_label')}
      onOk={handleCancel}
      onCancel={handleCancel}
    />
  );
};

export default RestreamingFailureRuntimeModal;
